export default "__VITE_ASSET__C6CJCV0r__"